import React, { useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'
import styles from './TextInput.module.scss'

interface TextInputProps {
  id?: string
  name?: string
  value: string
  onChange: (value: string) => void
  placeholder?: string
  type?: 'text' | 'email' | 'password' | 'url' | 'search'
  disabled?: boolean
  readOnly?: boolean
  error?: boolean
  className?: never
}

export const TextInput: React.FC<TextInputProps> = ({
  id, name, value, onChange, placeholder, type = 'text',
  disabled = false, readOnly = false, error = false,
}) => {
  const [visible, setVisible] = useState(false)
  const isPassword = type === 'password'

  if (!isPassword) {
    return (
      <input
        id={id}
        name={name}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        className={[styles.input, error ? styles.error : ''].filter(Boolean).join(' ')}
      />
    )
  }

  const Icon = visible ? EyeOff : Eye

  return (
    <div className={styles.wrapper}>
      <input
        id={id}
        name={name}
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        className={[styles.input, styles.passwordInput, error ? styles.error : ''].filter(Boolean).join(' ')}
      />
      <button
        type="button"
        className={styles.toggle}
        onClick={() => setVisible((v) => !v)}
        tabIndex={-1}
        aria-label={visible ? 'Hide password' : 'Show password'}
      >
        <Icon size={16} />
      </button>
    </div>
  )
}
